import _ from 'lodash'
import moment from 'moment';
// lodash mixins
_.mixin({
    // Recursively collect values for property using lodash
    toPairsDeep: obj => _.flatMap(
        _.toPairs(obj), ([k, v]) =>
            _.isObjectLike(v) ? _.toPairsDeep(v) : [[k, v]]),
    /**
     * Formata segundos em minutos se segundos > 60
     * @param {Number} sec 
     * @returns 
     */
    formatTimeSec: ( sec ) => sec >= 60 ? moment(sec*1000).format('mm:ss [min]') : moment(sec*1000).format('ss [seg]')
});